import { FC } from 'react';
import { TAllFilter } from 'shared/types/filters/allFilters';
import {
  SquareMeterAreaContainer,
  ApartmentsContainer,
  ElectronicTradingContainer,
  FlatShareContainer,
  BalconyContainer,
  BathTypeContainer,
  CeilingHeightContainer,
  CompletionYearContainer,
  ConstructionTypeContainer,
  ConstructionYearContainer,
  ContactPhoneContainer,
  ContainWordsContainer,
  ExcludeWordsContainer,
  DemolitionContainer,
  ElevatorsContainer,
  FacilitiesContainer,
  FinishingContainer,
  FlatRoomsContainer,
  FloorContainer,
  FloorsCountContainer,
  FromMkadContainer,
  GarageTypeContainer,
  GarageStatusContainer,
  GarageUtilitiesContainer,
  HeatingTypeContainer,
  EncumbranceRealtyContainer,
  SubsidizedMortgageContainer,
  KitchenStoveContainer,
  LandStatusContainer,
  LayoutContainer,
  LivingConditionsContainer,
  RoomsInDealContainer,
  RepairContainer,
  RentalPeriodContainer,
  RentTermsContainer,
  PublicationDateContainer,
  ParkingContainer,
  OfferTypeContainer,
  OfferIdContainer,
  MortgagePromoSearchTypeContainer,
  SaleTypeContainer,
  SuburbanAreaContainer,
  SuburbanAreaDailyRentContainer,
  SuburbanBathroomContainer,
  SuburbanFacilitiesContainer,
  SuburbanHouseTypeContainer,
  SuburbanUtilitiesContainer,
  UrbanBathroomContainer,
  WindowsContainer,
  WithNeighborsContainer,
  DecorationsListContainer,
  BedroomsContainer,
  SuburbanFloorsContainer,
  OfferSellerContainer,
  DiscountPromoSearchTypeContainer,
  UndergroundTimeContainer,
  RenovationContainer,
  OnlineBookingContainer,
  EarlyAccessContainer,
} from 'shared/containers/AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers';
import {
  DealTypeContainer,
  IsOwnerContainer,
  ObjectTypeContainer,
  PriceContainer,
  RoomTypeContainer,
} from '../../containers';
import { DatesContainer } from '../../containers/DatesContainer/DatesContainer';

export const ALL_FILTERS_MAP: Record<TAllFilter, FC> = {
  squareMeterArea: SquareMeterAreaContainer,
  apartments: ApartmentsContainer,
  electronicTrading: ElectronicTradingContainer,
  flatShare: FlatShareContainer,
  balcony: BalconyContainer,
  bathType: BathTypeContainer,
  ceilingHeight: CeilingHeightContainer,
  completionYear: CompletionYearContainer,
  constructionType: ConstructionTypeContainer,
  constructionYear: ConstructionYearContainer,
  contact: ContactPhoneContainer,
  containWords: ContainWordsContainer,
  demolition: DemolitionContainer,
  dealType: DealTypeContainer,
  elevators: ElevatorsContainer,
  excludeWords: ExcludeWordsContainer,
  facilities: FacilitiesContainer,
  finishing: FinishingContainer,
  flatRooms: FlatRoomsContainer,
  floor: FloorContainer,
  floors: FloorsCountContainer,
  fromMKAD: FromMkadContainer,
  garageType: GarageTypeContainer,
  garageStatus: GarageStatusContainer,
  garageUtilities: GarageUtilitiesContainer,
  heatingType: HeatingTypeContainer,
  isEncumbranceRealty: EncumbranceRealtyContainer,
  isOwner: IsOwnerContainer,
  subsidizedMortgage: SubsidizedMortgageContainer,
  kitchenStove: KitchenStoveContainer,
  landStatus: LandStatusContainer,
  layout: LayoutContainer,
  livingConditions: LivingConditionsContainer,
  mortgagePromoSearchType: MortgagePromoSearchTypeContainer,
  offerId: OfferIdContainer,
  offerType: OfferTypeContainer,
  onlineBooking: OnlineBookingContainer,
  parking: ParkingContainer,
  publicationDate: PublicationDateContainer,
  rentTerms: RentTermsContainer,
  rentalPeriod: RentalPeriodContainer,
  repair: RepairContainer,
  roomsInDeal: RoomsInDealContainer,
  saleType: SaleTypeContainer,
  suburbanArea: SuburbanAreaContainer,
  suburbanAreaDailyrent: SuburbanAreaDailyRentContainer,
  suburbanBathroom: SuburbanBathroomContainer,
  suburbanFacilities: SuburbanFacilitiesContainer,
  suburbanHouseType: SuburbanHouseTypeContainer,
  suburbanUtilities: SuburbanUtilitiesContainer,
  undergroundTime: UndergroundTimeContainer,
  urbanBathroom: UrbanBathroomContainer,
  windows: WindowsContainer,
  withNeighbors: WithNeighborsContainer,
  decorationsList: DecorationsListContainer,
  bedrooms: BedroomsContainer,
  suburbanFloors: SuburbanFloorsContainer,
  offerSeller: OfferSellerContainer,
  discountPromoSearchType: DiscountPromoSearchTypeContainer,
  objectType: ObjectTypeContainer,
  roomType: RoomTypeContainer,
  price: PriceContainer,
  renovation: RenovationContainer,
  earlyAccess: EarlyAccessContainer,
  dates: DatesContainer,
};
